import { formatCurrency } from "@scandotcom/react";
import {
  Map,
  MapMarker,
  useMap,
} from "@scandotcom/react/dist/esm/components/Map";
import { IconArrowRight } from "@tabler/icons-react";
import classNames from "classnames";
import React from "react";
import { LocationResult } from "../NewSearchResults/types";
import { LocationCard } from "./LocationCard";
import { Popup } from "./Popup";

interface Props {
  locations?: LocationResult[];
  serviceName?: string;
  modalitySlug?: string;
  cityName?: string;
}

export function LocationServicePageLocations({
  locations = [],
  serviceName,
  modalitySlug,
  cityName,
}: Props) {
  const {
    mapRef,
    selectedLocation: mapLoc,
    setLocation,
    fitToBounds,
  } = useMap(locations);

  const mapStyles = classNames(
    "lg:sticky top-4 h-[550px] w-full rounded-2xl lg:h-[1000px]",
    "max-lg:[&_.mapboxgl-ctrl-top-right]:!hidden row-span-3"
  );

  return (
    <div className="relative grid auto-rows-min gap-x-10 gap-y-4 lg:grid-cols-2">
      <div className="flex items-baseline justify-between gap-2">
        <h2 className="font-maison-extended text-2xl lg:text-xl">
          <span className="font-bold">Private {serviceName} locations</span>{" "}
          near {cityName}
        </h2>

        <a
          href="/locations"
          className="whitespace-nowrap font-medium text-green-800 underline hover:no-underline max-lg:hidden"
        >
          All locations
        </a>
      </div>

      <Map
        className={mapStyles}
        logoPosition="bottom-right"
        onLoad={fitToBounds}
        mapboxAccessToken={window.AppConfig.MAPBOX_ACCESS_TOKEN}
        ref={mapRef}
      >
        {locations.map((loc) => (
          <MapMarker
            key={loc.id}
            price={formatCurrency(loc.price / 100)}
            latitude={loc.latitude}
            longitude={loc.longitude}
            selected={loc.id === mapLoc?.id}
            onClick={() => setLocation(loc, true)}
          />
        ))}

        {mapLoc && (
          <Popup
            location={mapLoc}
            onClose={() => setLocation(null, true)}
            modalitySlug={modalitySlug}
          />
        )}
      </Map>

      <div className="grid gap-y-2">
        {locations.map((location) => (
          <LocationCard
            key={location.id}
            {...location}
            modalitySlug={modalitySlug}
          />
        ))}

        {!locations.length && (
          <p className="py-10 text-lg text-neutral-500">
            Sorry there are no private {serviceName} locations available in{" "}
            {cityName}.
          </p>
        )}

        <a
          href="/locations"
          className="flex gap-x-1 place-self-center font-medium text-green-800 underline hover:no-underline lg:hidden"
        >
          All locations <IconArrowRight width={20} />
        </a>
      </div>
    </div>
  );
}
